import React from 'react';

// CookiePolicy Component
const Cook = () => {
  return (
    <div className="cookie-container">
      <style>{`
       

        /* Container Styling */
        .cookie-container {
          margin: 20px auto;
          padding: 100px 7% 0px;
          line-height: 1.7;
        }

        /* Headings */
        .cookie-container h1 {
          font-size: 2.5em;
          color: #212529;
          margin-bottom: 25px;
          text-align: center;
          border-bottom: 2px solid #e9ecef;
          padding-bottom: 15px;
        }

        .cookie-container h2 {
          font-size: 1.8em;
          color: #212529;
          margin-top: 30px;
          margin-bottom: 15px;
        }

        .cookie-container h3 {
          font-size: 1.4em;
          color: #343a40;
          margin-top: 20px;
          margin-bottom: 10px;
        }

        /* Paragraphs */
        .cookie-container p {
          margin-bottom: 1em;
          font-size: 1em;
        }

        /* Lists */
        .cookie-container ul {
          list-style: disc;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .cookie-container ol {
          list-style: decimal;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .cookie-container li {
          margin-bottom: 0.5em;
        }

        /* Links */
        .cookie-container a {
          color: #007bff;
          text-decoration: none;
        }

        .cookie-container a:hover {
          text-decoration: underline;
        }

        /* Responsive Adjustments */
        @media (max-width: 768px) {
          .cookie-container {
            margin: 15px;
            padding: 20px;
          }

          .cookie-container h1 {
            font-size: 2em;
            margin-bottom: 20px;
          }

          .cookie-container h2 {
            font-size: 1.6em;
            margin-top: 25px;
          }

          .cookie-container h3 {
            font-size: 1.2em;
            margin-top: 18px;
          }

          .cookie-container p {
            font-size: 0.95em;
          }
        }

        @media (max-width: 480px) {
          .cookie-container {
            margin: 10px;
            padding: 15px;
            border-radius: 8px;
          }

          .cookie-container h1 {
            font-size: 1.8em;
            margin-bottom: 15px;
            padding-bottom: 10px;
          }

          .cookie-container h2 {
            font-size: 1.4em;
            margin-top: 20px;
          }

          .cookie-container h3 {
            font-size: 1.1em;
            margin-top: 15px;
          }

          .cookie-container ul,
          .cookie-container ol {
            margin-left: 20px;
          }
        }
      `}</style>

      <h1>Cookie Policy</h1>
      <p><em>Last updated: June 22, 2025</em></p>

      <p>This Cookie Policy explains what cookies are, how Haronics ("we," "us," or "our") uses cookies and similar technologies on our website Haronics (the "Site"), and your choices regarding cookies. By using our Site, you consent to the use of cookies in accordance with this policy.</p>

      <h2>1. What Are Cookies?</h2>
      <p>Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work, or work more efficiently, as well as to provide information to the owners of the site.</p>
      <p>Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your personal computer or mobile device when you go offline, while session cookies are deleted as soon as you close your web browser.</p>

      <h2>2. How We Use Cookies</h2>
      <p>We use cookies for the following purposes:</p>
      <ul>
        <li><strong>Essential Cookies:</strong> These cookies are strictly necessary to provide you with services available through our Site and to enable you to use some of its features, such as accessing secure areas. Without these cookies, services you have asked for cannot be provided.</li>
        <li><strong>Performance and Analytics Cookies:</strong> These cookies collect information about how visitors use our Site, for instance, which pages visitors go to most often, and if they get error messages from web pages. These cookies do not collect information that identifies a visitor. All information these cookies collect is aggregated and therefore anonymous. It is only used to improve how our Site works.</li>
        <li><strong>Functionality Cookies:</strong> These cookies allow our Site to remember choices you make (such as your user name, language, or the region you are in) and provide enhanced, more personal features. They may also be used to provide services you have asked for, such as watching a video or commenting on a blog.</li>
        <li><strong>Targeting/Advertising Cookies:</strong> These cookies are used to deliver advertisements more relevant to you and your interests. They are also used to limit the number of times you see an advertisement and help measure the effectiveness of advertising campaigns. They are usually placed by advertising networks with the website operator’s permission.</li>
      </ul>

      <h2>3. Third-Party Cookies</h2>
      <p>In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the Site, deliver advertisements on and through the Site, and so on.</p>

      <h2>4. Your Choices Regarding Cookies</h2>
      <p>You have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of our services or websites you visit.</p>
      <p>To learn more about how to manage cookies, visit your browser's help pages:</p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-4197-93a3-174b-d702d935aa9c" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
      </ul>

      <h2>5. Changes to This Cookie Policy</h2>
      <p>We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page. You are advised to review this Cookie Policy periodically for any changes. Changes to this Cookie Policy are effective when they are posted on this page.</p>

      <h2>6. Contact Us</h2>
      <p>If you have any questions about this Cookie Policy, please contact us at: <a href="mailto:privacy@haronics.com">privacy@haronics.com</a></p>
    </div>
  );
};

export default Cook;
